export default __webpack_public_path__ + "static/media/i220hp.6ad1782c.webp";